<script lang="ts">
  const year = new Date().getFullYear();
</script>

<footer class="site-footer">
  <div class="container footer-inner">
    <span class="footer-brand">Beat Duel</span>
    <nav class="footer-links">
      <a href="#/overview">About</a>
      <a href="#/account/invite">Invite</a>
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSc3nJ9q4hHUG7RpQDa4IENLEjYLQ98mrwmVXooeXhCOOLdf6Q/viewform?usp=header"
        target="_blank"
        rel="noopener">Suggestions</a
      >
      <a href="#/help">Help</a>
      <a href="#/terms">Terms</a>
      <a href="#/privacy">Privacy</a>
    </nav>
    <span class="footer-copy">&copy; {year} Beat Duel</span>
  </div>
</footer>

<style>
  .site-footer {
    border-top: 1px solid var(--border);
    padding: 1.5rem 0;
    margin-top: 2rem;
  }
  .footer-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8rem;
    color: var(--text-muted);
  }
  .footer-brand {
    font-weight: 600;
    letter-spacing: 0.3px;
  }
  .footer-links {
    display: flex;
    gap: 1.5rem;
  }
  .footer-links a {
    color: var(--text-muted);
  }
  .footer-links a:hover {
    color: var(--pink);
  }
  .footer-copy {
    color: var(--text-muted);
  }

  @media (max-width: 480px) {
    .footer-inner {
      flex-direction: column;
      gap: 0.5rem;
      text-align: center;
    }
  }

  /* Hide footer on mobile — tab bar replaces it */
  @media (max-width: 767px) {
    .site-footer {
      display: none;
    }
  }
</style>
